import { useContext } from 'react';
import LayautContext from 'Context/ContextLayaut';

const ServiciosNotificaciones = () => {
    const context = useContext(LayautContext);
    return {
        // Notificaciones
        getNotificaciones: context.llamarServidor('Notificaciones/getNotificaciones'),
        guardaNotificacion: context.llamarServidorRespuesta('Notificaciones/guardaNotificacion'),
        editaNotificacion: context.llamarServidorRespuesta('Notificaciones/editaNotificacion'),
        eliminaNotificacion: context.llamarServidorRespuesta('Notificaciones/eliminaNotificacion'),
        cambiarEstatusNotificacion: context.llamarServidorRespuesta('Notificaciones/cambiarEstatusNotificacion')
    };
};

export default ServiciosNotificaciones;
